import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tog-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss']
})
export class TableRowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/table/table-row/table-row.component.ts